import clsx from "clsx";
import { Checkbox } from "@/shared/ui";
import { CreateCharacterState } from "@/domains/createCharacter/slice";

type Props = {
  steps: CreateCharacterState["stepValues"];
  step: number;
  setStep: (step: number) => void;
};

export default function CreateCharacterSteps({ steps, step, setStep }: Props) {
  return (
    <div className="absolute top-[--boundary-offset-x] right-[calc(var(--customization-side-w)+var(--boundary-offset-x))] overflow-hidden card p-0 rounded-r-none">
      {steps.map((item) => {
        const isAvailable = !steps.slice(0, item.index).some((itemStep) => !itemStep.isCorrect);
        return (
          <button
            key={item.index}
            type="button"
            className={clsx(
              "flex flex-col justify-center items-center aspect-[1.1] w-[--customization-steps-w] font-bold group  relative z-1",
              item.index === step ? "bg-gradient-to-r from-accent-solid/20 to-transparent" : "",
              !isAvailable && "grayscale pointer-events-none",
            )}
            onClick={() => setStep(item.index)}
          >
            <div className="mb-2.5 text-sm">{item.title}</div>
            <Checkbox checked={item.isCorrect} onChange={() => {}} />
          </button>
        );
      })}
    </div>
  );
}
